export const formatDate = (dateString, options = { day: 'numeric', month: 'long', year: 'numeric' }) => {
    if (!dateString) return '';
    let date = new Date(dateString);

    if (isNaN(date.getTime())) {
        date = new Date(dateString.replace(/-/g, '/'));
    }

    if (isNaN(date.getTime())) {
        console.error("Formato de fecha no reconocido:", + dateString);
        return 'Fecha Inválida'
    }
    return date.toLocaleDateString('es-ES', options);
}

export const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false });
}